import { PaginatedListResponse } from "@/domain/dto/BaseDataResponse"
import { ListPrescriptionFeedbackQueryParamsDTO } from "@/domain/dto/ListPrescriptionFeedbackQueryParamsDTO"
import { PrescriptionFeedback } from "@/domain/entities/PrescriptionFeedback"
import { UserSubscriptionTransaction } from "@/domain/entities/UserSubscriptionTransaction"
import { IUserRepository } from "@/domain/repositories/IUserRepository"
import { IUserRemoteDataSource } from "../datasources/interfaces/remote/IUserRemoteDataSource"
import PrescriptionFeedbackMappers from "../mappers/PrescriptionFeedbackMappers"
import ResponseDataMappers from "../mappers/ResponseDataMappers"
import UserSubscriptionHistoryDataMappers from "../mappers/UserSubscriptionHistoryDataMappers"

export class UserRepository implements IUserRepository {
    dataSource: IUserRemoteDataSource
    constructor(dataSource: IUserRemoteDataSource) {
        this.dataSource = dataSource
    }

    async listSubscriptionHistory(userId: string): Promise<UserSubscriptionTransaction[]> {
        const response = await this.dataSource.list(userId)
        console.log(response)
        return UserSubscriptionHistoryDataMappers.toTransactionList(response.data)
    }

    async listPrescriptionFeedback(params: ListPrescriptionFeedbackQueryParamsDTO): Promise<PaginatedListResponse<PrescriptionFeedback>> {
        const response = await this.dataSource.listPrescriptionFeedback(params)
        return ResponseDataMappers.toPaginatedListResponse(response, response.data.map(PrescriptionFeedbackMappers.toEntity))
    }
}
